import React from 'react'
import Svg from './Svg'
export const SvgSortAsc = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 0h9v6H0zM0 9h15v6H0zM0 18h24v6H0z" />
  </Svg>
))
SvgSortAsc.isIcon = true
export default SvgSortAsc
